"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpiredContextProvider = exports.ExpiredContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
exports.ExpiredContext = (0, react_1.createContext)({
    onUnselected: () => null,
    checkList: {},
    toggleItem: () => false,
});
const ExpiredContextProvider = ({ checkList, setCheckList, onUnselected, children }) => {
    const toggleItem = (productId) => setCheckList(Object.assign(Object.assign({}, checkList), { [productId]: !checkList[productId] }));
    return (0, jsx_runtime_1.jsx)(exports.ExpiredContext.Provider, { value: { checkList, onUnselected, toggleItem }, children: children });
};
exports.ExpiredContextProvider = ExpiredContextProvider;
